'use strict';

goog.provide("Ntry.RunningScript");

goog.require("Ntry.STATIC");
goog.require("Ntry.Script");

Ntry.RunningScript = function(data) {
    if (data && data.xml) {
        this.script = new Ntry.Script(data.entity);
        this.script.init(data.xml);
    }
}

Ntry.RunningScript.prototype.type =
    Ntry.STATIC.RUNNING_SCRIPT;
